{
  "#PMS_ROSTER": {
    "TITLE": "Dienstplaner"
  },
  "#GARAGE_ROSTER": {
    "NO_DATA": "Keine Daten zum Anzeigen vorhanden",
    "GARAGE_TASKS": {
      "TITLE": "Aufgaben",
      "FIXED_PRICE": "Festpreis",
      "TIME_BASED": "Zeitbasiert",
      "UNPRODUCTIVE": "Unproduktiv"
    },
    "GARAGE_ORDERS": "Aufträge"
  }
}
